import { Link } from "react-router-dom";

const SiteFooter = ({ compact = false, className = "" }) => {
  const year = new Date().getFullYear();
  return (
    <footer className={`border-t border-border/60 bg-card/70 ${className}`}>
      <div className={`mx-auto max-w-7xl px-4 lg:px-8 ${compact ? "py-4" : "py-6"} flex flex-col gap-3 md:flex-row md:items-center md:justify-between`}>
        <p className="text-xs text-muted-foreground">
          © {year} The Eagle Logistics. All rights reserved.
        </p>
        <nav className="flex flex-wrap items-center gap-4 text-sm">
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/">Dashboard</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/about">About</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/investors">Investors</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/careers">Careers</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/navigation">Navigation</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/emergency-services">Emergency Services</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/terms">Terms</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/privacy">Privacy</Link>
          <Link className="text-muted-foreground hover:text-foreground transition-colors" to="/sitemap">Sitemap</Link>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;
